import {combineReducers} from 'redux'
import {reducer as formReducer} from 'redux-form'

import authentication from './reducer-autenticacao'
import empresaSelecionada from './reducer-empresa-selecionada'
import loading from './reducer-loading'
import datasRejeitadas from './reducer-filtros-data-rejeitadas'
import urls from './reducer-urls'

import empresas from './empresa/reducer-empresas'
import empresasGestao from './empresa/reducer-empresas-gestao'
import usuarioSelecionado from './usuario/reducer-usuario-selecionado'
import empresa from './empresa/reducer-empresa'
import motoristas from './usuario/reducer-motoristas'
import usuarios from './usuario/reducer-usuarios'
import usuariosEmpresa from './usuario/reducer-usuarios-empresa'
import usuariosRelatorio from './usuario/reducer-usuarios-relatorio'
import veiculos from './veiculo/reducer-buscar-veiculo'
import paginaAtualVeiculo from './veiculo/reducer-pagina-veiculo'
import registrosPorPaginaVeiculo from './veiculo/reducer-registros-por-paginal-veiculo'
import trechos from './trecho/reducer-buscar-trechos'
import rotas from './rota/reducer-rotas'
import rotasItinerario from './rota-itinerario/reducer-rota-itinerario'
import cidades from './cidade/reducer-buscar-cidade'
import localizacaoVeiculo from './veiculo/reducer-localizacao-veiculo'
import paginaAtualCidade from './cidade/reducer-pagina-cidade'
import registrosPorPaginaCidade from './cidade/reducer-registros-por-paginal-cidade'
import itinerarios from './itinerario/reducer-itinerarios'
import relatorioItinerarios from './itinerario/reducer-relatorio-itinerarios'
import relatorioItinerariosInicial from './itinerario/reducer-relatorio-itinerarios-inicial'
import itinerarioSelecionado from './itinerario/reducer-itinerario-selecionado'
import itinerariosSelecionados from './itinerario/reducer-itinerarios-selecionados'
import veiculoItinerarioSelecionado from './itinerario/reducer-veiculo-itinerario-selecionado'
import detalhamentoFinanceiroItinerario from './itinerario/reducer-detalhamento-financeiro-itinerario'
import detalhamentoFinanceiroEncomenda from './itinerario/reducer-detalhamento-financeiro-encomenda'
import precoPaginacao from './preco/reducer-buscar-precos'
import precosRota from './preco/reducer-precos-rota'
import tiposPreco from './preco/reducer-tipos-preco'
import precoRecuperado from './preco/reducer-buscar-preco-volta'
import paginaAtualPreco from './preco/reducer-pagina-atual-preco'
import registrosPorPaginaPreco from './preco/reducer-registros-por-paginal-precos'
import poltronasSelecionadas from './poltrona/reducer-poltronas-selecionadas'
import viagens from './viagem/reducer-buscar-viagens'
import viagem from './viagem/reducer-selecionar-viagem'
import destino from './destino/reducer-selecionar-destino'
import dataVolta from './destino/reducer-selecionar-data-volta'
import origem from './origem/reducer-selecionar-origem'
import dataIda from './origem/reducer-selecionar-data-ida'
import criarReserva from './reserva/reducer-selecionar-reserva-para-criar'
import reserva from './reserva/reducer-reserva'
import passageiros from './passageiro/reducer-adicionar-passageiro'
import pedidos from './pedido/reducer-buscar-pedidos'
import bloqueioPoltronasTemporario from './pedido/reducer-bloqueio-poltronas-temporario'
import pedido from './pedido/reducer-pedido'
import paginaAtualItinerario from './itinerario/reducer-pagina-atual-itinerario'
import registrosPorPaginaItinerario from './itinerario/reducer-registros-por-paginal-itinerario'
import perfisSelecionados from './perfil/reducer-selecionar-perfis'
import rotaSelecionada from './rota/reducer-rota-selecionada'
import conexaoSelecionada from './rota/reducer-conexao-selecionada'
import tipoVeiculoSelecionado from './tipoVeiculo/reducer-selecionar-tipo-veiculo'
import cupom from './cupom/reducerCupom';
import messages from './messagesReducer';
import ehVendaEmMassa from './viagem/reducerVendaEmMassa';

import {filtrosAdicionadosPedido, filtrosPedidos} from './pedido/reducer-filtro-pedido'

import {filtrosAdicionadosUsuarios, filtrosUsuarios} from './usuario/reducer-filtro-usuario'

import {filtrosAdicionadosAgencia, filtrosAgencia} from './agencia/reducer-filtro-agencia'
import {filtrosAdicionadosPrestador} from './prestador/reducer-filtro-prestador'

import {filtrosAdicionadosEmpresas, filtrosEmpresas} from './empresa/reducer-filtro-empresa'

import {filtrosAdicionadosCupom, filtrosCupom} from './cupom/reducer-filtro-cupom'
import {filtrosAdicionadosBagagem, filtrosBagagem} from './bagagem/reducer-filtro-bagagem'

import {
    filtrosAdicionadosFechamentoCaixa,
    filtrosFechamentoCaixa
} from './fechamento-caixa/reducer-filtro-fechamento-caixa'

import fechamentosCaixa from './fechamento-caixa/reducer-buscar-fechamentos-caixa'
import fechamentoCaixa from './fechamento-caixa/reducer-fechamento-caixa'
import exportarFechamentosCaixa from './fechamento-caixa/reducer-exportar-fechamentos-caixa'
import resumoFinanceiro from './resumo-financeiro/reducer-resumo-financeiro'
import vexadoBI from './reducer-vexado-bi/reducer-vexado-bi'
import fechamentoCaixaDia from './fechamento-caixa/reducer-fechamento-caixa-dia'
import caixaAberto from './fechamento-caixa/reducer-caixa-aberto'
import reservas from './reserva/reducer-buscar-reservas'
import reservasBpe from './reserva/reducer-buscar-reservas-bpe-itinerario'
import registrosPorPaginaReservaBpe from './reserva/reducer-registros-por-pagina-reserva-bpe'
import paginaAtualReservaBpe from './reserva/reducer-pagina-atual-reserva-bpe'
import cidade from './cidade/reducer-cidade'

import mapasVeiculos from './mapa-veiculo/reducer-mapas-veiculos'
import paginaAtualMapasVeiculos from './mapa-veiculo/reducer-pagina-mapas-veiculos'
import registrosPorPaginaMapasVeiculos from './mapa-veiculo/reducer-registros-por-paginal-mapas-veiculos'
import mapaVeiculo from './mapa-veiculo/reducer-mapa-veiculo'
import mapaVeiculoItinerarioIda from './mapa-veiculo/reducer-mapa-veiculo-itinerario-ida'
import mapaVeiculoItinerarioVolta from './mapa-veiculo/reducer-mapa-veiculo-itinerario-volta'
import mapaVeiculoItinerario from './mapa-veiculo/reducer-mapa-veiculo-itinerario'
import filtrosMapaVeiculo from './mapa-veiculo/reducer-filtro-mapa-veiculo'
import pessoaRemetente from './pessoa/reducer-pessoa-remetente'
import tiposDocumento from './pessoa/reducer-tipos-documento'
import pessoaDestinatario from './pessoa/reducer-pessoa-destinatario'
import enderecoDestinatario from './endereco/reducer-endereco-destinatario'
import enderecoRemetente from './endereco/reducer-endereco-remetente'
import endereco from './endereco/reducer-endereco'
import dadosPagamentoEncomenda from './encomenda/reducer-dados-pagamento-encomenda';
import {USER_LOGOUT} from '../actions/types';
import encomenda from './encomenda/reducer-encomenda';
import configuracaoEncomenda from './empresa/reducer-configuracao-encomenda';
import encomendas from './encomenda/reducer-encomendas'
import paginaAtualUsuario from './usuario/reducer-pagina-usuario'
import paginaAtualAgencia from './agencia/reducer-pagina-agencia'
import paginaAtualPrestador from './prestador/reducer-pagina-prestador'
import registrosPorPaginaPrestador from './prestador/reducer-registros-por-paginal-prestador'
import prestadores from './prestador/reducer-prestadores'
import registrosPorPaginaUsuario from './usuario/reducer-registros-por-paginal-usuario'
import registrosPorPaginaAgencia from './agencia/reducer-registros-por-paginal-agencia'
import agencias from './agencia/reducer-agencias'
import registrosPorPaginaPedido from './pedido/reducer-registros-por-paginal-pedido'
import paginaAtualPedido from './pedido/reducer-pagina-atual-pedido'
import viagemIda from './viagem/reducer-viagem-ida'
import viagemVolta from './viagem/reducer-viagem-volta'
import dadosPagamento from './viagem/reducer-dados-pagamento';
import formasPagamento from './viagem/reducer-forma-pagamento'
import opcaoDescontoMeiaPassagem from './usuario/reducer-opcao-desconto-meia-passagem'

import passageiro from './passageiro/reducer-selecionar-passageiro'
import passageirosVolta from './passageiro/reducer-passageiros-volta'
import passageirosIda from './passageiro/reducer-passageiros-ida'

import registrosPorPaginaFechamentoCaixa from './fechamento-caixa/reducer-registros-por-paginal-fechamento-caixa'
import paginaAtualFechamentoCaixa from './fechamento-caixa/reducer-pagina-atual-fechamento-caixa'
import mapaViagem from './itinerario/reducer-mapa-viagem'
import pessoaExterna from './pessoa/reducer-pessoa-base-externa'
import remarcacao from './remarcacao/reducer-remarcacao'

import registrosPorPaginaEncomenda from './encomenda/reducer-registros-por-pagina-encomenda'
import paginaAtualEncomenda from './encomenda/reducer-pagina-atual-encomenda'
import quantidadeGratuidadeOcupadas from './poltrona/reducer-quantidade-gratuidade'
import tiposEmissoesSelecionados from './tipo-emissao/reducer-selecionar-tipos-emissoes'
import descontosUsuarioRota from './usuario/reducer-descontos-usuario-rota';
import descontoUsuarioRotaSelecionado from './desconto/reducer-desconto-usuario-rota-selecionado';
import valorDescontoUsuarioCalculado from './desconto/reducer-selecionar-valor-desconto-calculado';
import impostoEmpresa from './imposto-empresa/reducer-imposto-empresa'
import plataformas from './empresa/reducer-plataformas'
import configuracaoBPe from './configuracao-bpe/reducer-configuracao-bpe';
import configuracaoBilhete from './configuracao-bilhete/reducer-configuracao-bilhete';
import configuracaoBilheteSelecionado from './configuracao-bilhete/reducer-configuracao-selecionada';
import regraCalculoBilhete from './configuracao-bilhete/reducer-regra-bilhete'

import {filtrosAdicionadosEncomenda, filtrosEncomenda} from './encomenda/reducer-filtro-encomenda'

import registrosPorPaginaEmpresa from './empresa/reducer-registros-por-paginal-empresa';
import paginaAtualEmpresa from './empresa/reducer-pagina-atual-empresa';

import usuariosEmpresaAgencia from './usuario-empresa-agencia/reducer-resumo-financeiro';
import {
    paginaAtualSelecaoEmpresa,
    registrosPorPaginaSelecaoEmpresa
} from './selecao-empresas/reducer-paginacao-selecao-empresa';

import {
    paginaAtualResumoFinanceiro,
    registrosPorPaginaResumoFinanceiro
} from './resumo-financeiro/reducer-paginacao-resumo-financeiro';


import {
    paginaAtualRelatorioItinerarios,
    registrosPorPaginaRelatorioItinerarios
} from './itinerario/reducer-paginacao-relatorio-itinerarios';

import {paginaAtualRota, registrosPorPaginaRota} from './rota/reducer-paginacao-rota';

import {paginaAtualRotaItinerario, registrosPorPaginaRotaItinerario} from './rota-itinerario/reducer-paginacao-rota-itinerario'

import {filtrosAdicionadosRota, filtrosRotas} from './rota/reducer-filtro-rota'

import {filtrosAdicionadosRotaItinerario, filtrosRotasItinerario} from './rota-itinerario/reducer-filtro-rota-itinerario'

import {filtrosAdicionadosItinerario, filtrosItinerarios} from './itinerario/reducer-filtro-itinerario'

import interessadoPromocao from './ineteressado-promocao/reducerInteressadosPromocao'

import ativacaoItinerarioEmLote from './itinerario/reducer-ativacao-itinerario-em-lote'
import custoItinerario from './itinerario/reducer-buscar-custos-itinerario'
import rotasParaImportacao from './rota/reducer-importar-rotas'
import repasseVenda from './repasse-venda/repasse-venda'
import repasseVendaSelecionado from './repasse-venda/reducer-repasse-venda-selecionado'
import cadastroRepasseVenda from './repasse-venda/reducer-cadastro-repasse-venda'
import parametrosBuscaRepasseSelecionado from './repasse-venda/reducer-parametros-busca-repasse-selecionado'
import reservasRepasse from './repasse-venda/reservas-repasse'
import transferenciaReservasItinerario from './reserva/reducer-transferencia-reserva-itinerario'
import reservasTransferencia from './reserva/reducer-selecionar-reservas-transferencia'
import itinerariosFuturo from './itinerario/reducer-itinerarios-futuro'

import {filtrosAdicionadosItinerarioEmbarque, filtrosItinerarioEmbarque } from './itinerario/reducer-filtro-embarque-passageiro'
import paginaAtualItinerarioEmbarque from './itinerario/reducer-pagina-atual-itinerario-embarque';
import registrosPorPaginaAtualItinerarioEmbarque from './itinerario/reducer-registros-por-paginal-itinerario-embarque'

import mapaSelecionadoVeiculo from './veiculo/reducer-alterar-mapa-selecionado-veiculo'
import veiculoSelecionado from './veiculo/reducer-selecionar-veiculo'
import agrupadosDisponibilidadesVeiculo from './disponibilidade-veiculo/reducer-agrupados-disponibilidades-veiculo'
import agrupadoDisponibilidadeVeiculoSelecionado from './disponibilidade-veiculo/reducer-agrupado-disponibilidade-veiculo-selecionado'
import disponibilidadesVeiculo from './disponibilidade-veiculo/reducer-disponibilidades-veiculo'
import disponibilidadeVeiculoSelecionado from './disponibilidade-veiculo/reducer-disponibilidade-veiculo-selecionado'
import veiculosDisponiveis from './agendamento-viagem/reducer-veiculos-disponiveis'
import pessoaContratante from './pessoa/reducer-pessoa-contratante'
import agendamentosViagens from './agendamento-viagem/reducer-agendamentos-viagens'
import agendamentoViagemSelecionado from './agendamento-viagem/reducer-agendamento-viagem-selecionado'
import { filtrosAdicionadosAgendamentoViagem, filtrosAgendamentoViagem } from './agendamento-viagem/reducer-filtro-agendamento-viagem';
import imagensEncomenda from './encomenda/reducer-cadastro-imagens-encomenda'
import buscarEncomendaItinerario from './encomenda/reducer-encomenda'

import mapaVeiculoAgendamentoViagem from './mapa-veiculo/reducer-mapa-veiculo-agendamento-viagem'
import agendamentoViagem from './agendamento-viagem/reducer-agendamento-viagem'

import emissoesCteOs from './cteos/reducer-buscar-emissoes-cte-os'
import emissaoCteOsSelecionado from './cteos/reducer-emissao-cte-os-selecionado'
import opcoesFiltrosEmissaoesCteOs from './cteos/reducer-buscar-opcoes-filtros-emissaoes-cte-os'
import tomadores from './cteos/reducer-buscar-tomadores'
import tomador from './cteos/reducerTomadores'
import emissaoCteOsNotaFiscal from './cteos/reducer-buscar-emissao-cte-os-nota-fiscal'
import registrosPorPaginalCteOs from './cteos/reducer-registros-por-paginal-cte-os'
import paginaAtualCteOs from './cteos/reducer-pagina-atual-cte-os'

import { filtrosAdicionadosCteOs, filtrosCteOs } from './cteos/reducer-filtro-cte-os'

import opcoesFiltrosEmissaoesCte from './cteos/reducer-buscar-opcoes-filtros-emissaoes-cte'
import usuarioVendeEncomendaComCte from './usuario/reducer-usuario-vende-encomenda-com-cte'
import dadosCteEncomenda from './encomenda/reducer-dados-cte-encomenda'
import valorAcrescimoPassagemCalculado from './acrescimo-passagem/reducer-selecionar-valor-acrescimo-passagem-calculado'
import acrescimoPassagemUsuarioSelecionado from './acrescimo-passagem/reducer-acrescimo-passagem-usuario-selecionado'

import veiculo from './veiculo/reducer-buscar-veiculo-empresa'
import manutencoesVeiculo from './manutencao-veiculo/reducer-buscar-manutencoes-veiculo'
import { filtrosAdicionadosManutencaoVeiculo } from './manutencao-veiculo/reducer-filtro-manutencao-veiculo'
import opcoesFiltrosConfiguracaoBilhete from './configuracao-bilhete/reducer-buscar-opcoes-filtros-configuracao-bilhete'

import ultimosHistoricosRota from './rota/reducer-ultimos-historicos-rota'
import ultimosHistoricosUsuario from './usuario/reducer-ultimos-historicos-usuario'
import ultimosHistoricosPreco from './preco/reducer-ultimos-historicos-preco'
import ultimosHistoricosTrecho from './trecho/reducer-ultimos-historicos-trechos'
import ultimosHistoricosItinerario from './itinerario/reducer-ultimos-historicos-itinerario'

import adesaoPontos from './adesao-pontos/reducer-adesao-pontos'
import opcoesFiltrosAdesaoPontos from './adesao-pontos/reducer-buscar-opcoes-filtros-adesao-pontos'
import adesaoPontoSelecionado from './adesao-pontos/reducer-adesao-ponto-selecionado'
import adesaoPontoEmpresa from './adesao-pontos/reducer-adesao-ponto-empresa'
import buscarClientesEmpresa from './adesao-pontos/reducer-buscar-clientes-empresa'
import historicosTransferenciasPassageiros from './itinerario/reducer-historicos-transferencias-passageiros'
import agenciasEmpresa from './agencia/reducer-agencias-empresa'
import trechoPassageiroSelecionado from './itinerario/reducer-trecho-passageiro-selecionado'
import trechosReservasItinerario from './reserva/reducer-trechos-reservas-itinerario'
import cidadesTrechos from './trecho/reducer-buscar-cidades-trechos'
import usuariosVendedores from './usuario/reducer-usuarios-vendedores'
import centroCusto from './centro-custo/centroCustoReducer';
import { filtrosAdicionadosCentroCusto}  from './centro-custo/reducer-filtro-centro-custo';
import paginaAtualCentroCusto from './centro-custo/reducer-pagina-atual-centro-custo';
import registrosPorPaginaCentroCusto from './centro-custo/reducer-registros-por-paginal-centro-custo';
import usuarioBloqueadoEdicaoReimpressaoCupom from './usuario/reducer-usuario-bloqueado-edicao-reimpressao-cupom';
import temVinculoItinerarioEMotorista from './itinerario/reducer-verificar-vinculo-itinerario-e-motorista';

import bagagem from './bagagem/bagagemReducer';
import registrosPorPaginaBagagem from './bagagem/reducer-registros-por-paginal-bagagem';
import paginaAtualBagagem from './bagagem/reducer-pagina-atual-bagagem';
import pagamentosDesativados from './forma-pagamento/reducer-pagamentos-desativados';

import ultimosHistoricosPassageiro from './pedido/reducer-ultimos-historicos-passageiro';

import reservaSelecionadaReembolsoSocilitado from './reserva/reducer-seleciona-reserva-reembolso-solicitado'




const appReducer = combineReducers({
    authentication,
    form: formReducer,

    empresaSelecionada,
    loading,

    datasRejeitadas,

    // documento

    // urls gerais
    urls,

    empresas,
    empresasGestao,
    empresa,
    filtrosAdicionadosEmpresas,
    filtrosEmpresas,
    registrosPorPaginaEmpresa,
    paginaAtualEmpresa,


    usuarios,
    usuariosEmpresa,
    usuariosRelatorio,
    usuarioSelecionado,
    paginaAtualUsuario,
    registrosPorPaginaUsuario,
    filtrosAdicionadosUsuarios,
    filtrosUsuarios,
    motoristas,

    //Gerenciar Agencia
    paginaAtualAgencia,
    registrosPorPaginaAgencia,
    filtrosAdicionadosAgencia,
    filtrosAgencia,

    paginaAtualPrestador,
    registrosPorPaginaPrestador,
    filtrosAdicionadosPrestador,


    veiculos,
    paginaAtualVeiculo,
    registrosPorPaginaVeiculo,

    trechos,
    rotas,
    rotaSelecionada,
    conexaoSelecionada,
    paginaAtualRota,
    registrosPorPaginaRota,
    paginaAtualRotaItinerario,
    registrosPorPaginaRotaItinerario,
    filtrosAdicionadosRota,
    filtrosRotas,
    filtrosAdicionadosRotaItinerario,
    filtrosRotasItinerario,
    rotasItinerario,

    itinerarios,
    relatorioItinerarios,
    relatorioItinerariosInicial,
    itinerarioSelecionado,
    itinerariosSelecionados,
    detalhamentoFinanceiroItinerario,
    mapaViagem,
    registrosPorPaginaItinerario,
    paginaAtualItinerario,
    filtrosAdicionadosItinerario,
    filtrosItinerarios,

    precoPaginacao,
    precosRota,
    registrosPorPaginaPreco,
    paginaAtualPreco,
    precoRecuperado,

    cidades,
    paginaAtualCidade,
    registrosPorPaginaCidade,

    poltronasSelecionadas,
    quantidadeGratuidadeOcupadas,

    viagens,
    viagem,
    viagemIda,
    viagemVolta,

    origem,
    dataIda,
    destino,
    dataVolta,

    criarReserva,

    passageirosIda,
    passageirosVolta,
    passageiro,
    passageiros,
    pedidos,
    pedido,
    filtrosAdicionadosPedido,
    filtrosPedidos,

    perfisSelecionados,

    tipoVeiculoSelecionado,

    // Fechamento de caixa
    fechamentosCaixa,
    fechamentoCaixa,
    exportarFechamentosCaixa,
    resumoFinanceiro,
    fechamentoCaixaDia,
    reservas,
    reserva,
    reservasBpe,
    registrosPorPaginaReservaBpe,
    paginaAtualReservaBpe,
    cidade,
    caixaAberto,
    filtrosAdicionadosFechamentoCaixa,
    filtrosFechamentoCaixa,


    // Mapas veiculos
    mapasVeiculos,
    paginaAtualMapasVeiculos,
    registrosPorPaginaMapasVeiculos,
    mapaVeiculo,
    tiposPreco,
    mapaVeiculoItinerarioIda,
    mapaVeiculoItinerarioVolta,
    filtrosMapaVeiculo,
    mapaVeiculoItinerario,

    // PESSOA
    pessoaRemetente,
    enderecoRemetente,
    pessoaDestinatario,
    enderecoDestinatario,
    endereco,
    dadosPagamentoEncomenda,
    encomenda,
    encomendas,
    pessoaExterna,
    tiposDocumento,
    agencias,
    prestadores,
    registrosPorPaginaPedido,
    paginaAtualPedido,
    dadosPagamento,
    formasPagamento,
    opcaoDescontoMeiaPassagem,
    registrosPorPaginaFechamentoCaixa,
    paginaAtualFechamentoCaixa,
    registrosPorPaginaEncomenda,
    paginaAtualEncomenda,
    remarcacao,
    tiposEmissoesSelecionados,
    descontosUsuarioRota,
    descontoUsuarioRotaSelecionado,
    valorDescontoUsuarioCalculado,
    impostoEmpresa,
    configuracaoBPe,
    configuracaoBilhete,
    configuracaoBilheteSelecionado,
    regraCalculoBilhete,
    usuariosEmpresaAgencia,
    paginaAtualSelecaoEmpresa,
    registrosPorPaginaSelecaoEmpresa,
    plataformas,
    paginaAtualResumoFinanceiro,
    registrosPorPaginaResumoFinanceiro,
    localizacaoVeiculo,
    messages,
    paginaAtualRelatorioItinerarios,
    registrosPorPaginaRelatorioItinerarios,

    filtrosAdicionadosEncomenda,
    filtrosEncomenda,

    cupom,

    interessadoPromocao,

    ehVendaEmMassa,

    filtrosAdicionadosCupom,
    filtrosCupom,
    bloqueioPoltronasTemporario,

    ativacaoItinerarioEmLote,
    custoItinerario,

    rotasParaImportacao,

    vexadoBI,

    repasseVenda,
    repasseVendaSelecionado,
    cadastroRepasseVenda,
    parametrosBuscaRepasseSelecionado,
    reservasRepasse,
    detalhamentoFinanceiroEncomenda,

    veiculoItinerarioSelecionado,

    filtrosAdicionadosItinerarioEmbarque,
    filtrosItinerarioEmbarque,
    paginaAtualItinerarioEmbarque,
    registrosPorPaginaAtualItinerarioEmbarque,

    transferenciaReservasItinerario,
    reservasTransferencia,
    itinerariosFuturo,
    mapaSelecionadoVeiculo,
    veiculoSelecionado,
    agrupadosDisponibilidadesVeiculo,
    disponibilidadesVeiculo,
    disponibilidadeVeiculoSelecionado,
    configuracaoEncomenda,

    veiculosDisponiveis,
    pessoaContratante,
    agendamentosViagens,
    agendamentoViagemSelecionado,
    filtrosAdicionadosAgendamentoViagem,
    filtrosAgendamentoViagem,
    agrupadoDisponibilidadeVeiculoSelecionado,
    imagensEncomenda,
    buscarEncomendaItinerario,

    mapaVeiculoAgendamentoViagem,
    agendamentoViagem,

    tomadores,
    emissoesCteOs,
    emissaoCteOsSelecionado,
    opcoesFiltrosEmissaoesCteOs,
    opcoesFiltrosEmissaoesCte,
    tomador,
    emissaoCteOsNotaFiscal,
    registrosPorPaginalCteOs,
    paginaAtualCteOs,

    filtrosAdicionadosCteOs,
    filtrosCteOs,

    usuarioVendeEncomendaComCte,
    dadosCteEncomenda,
    
    valorAcrescimoPassagemCalculado,
    acrescimoPassagemUsuarioSelecionado,

    veiculo,
    manutencoesVeiculo,
    filtrosAdicionadosManutencaoVeiculo,

    opcoesFiltrosConfiguracaoBilhete,

    ultimosHistoricosRota,
    ultimosHistoricosUsuario,
    ultimosHistoricosPreco,
    ultimosHistoricosTrecho,
    ultimosHistoricosItinerario,

    adesaoPontos,
    opcoesFiltrosAdesaoPontos,
    adesaoPontoSelecionado,
    adesaoPontoEmpresa,
    buscarClientesEmpresa,

    historicosTransferenciasPassageiros,

    agenciasEmpresa,

    trechoPassageiroSelecionado,
    trechosReservasItinerario,
    
    cidadesTrechos,

    usuariosVendedores,

    centroCusto,
    filtrosAdicionadosCentroCusto,
    registrosPorPaginaCentroCusto,
    paginaAtualCentroCusto,
    usuarioBloqueadoEdicaoReimpressaoCupom,
    temVinculoItinerarioEMotorista,

    filtrosAdicionadosBagagem,
    filtrosBagagem,
    bagagem,
    registrosPorPaginaBagagem,
    paginaAtualBagagem,
    pagamentosDesativados,
    ultimosHistoricosPassageiro,
    reservaSelecionadaReembolsoSocilitado,
});

const rootReducer = (state, action) => {
    if (action.type === USER_LOGOUT) {
        // eslint-disable-next-line no-param-reassign
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer
